import { defineStore } from 'pinia'
import { Cookie } from '@/utils'

export interface Area {
	area_id: number
	name: string
	sort: number
	language_id: number
	laravel_through_key: number
}

export interface CountryInfo {
	id: number
	iso_code: string
	currency: string
	country_name: string
	website: string
	language: string
	area?: Area[]
	countries_id: number
	language_id: number
	warehouse: string
	isEuUnion: boolean
	locale?: string
	tel_prefix?: string
	timezone: string
	symbol: string
	seo_lang_code: string
}

const DEFAULT_WEBSITE = {
	id: 302,
	iso_code: 'US',
	currency: 'USD',
	country_name: 'United States',
	website: 'en',
	language: 'English',
	area: [{ area_id: 1, name: 'North America', sort: 0, language_id: 1, laravel_through_key: 302 }],
	countries_id: 223,
	language_id: 1,
	warehouse: 'US',
	isEuUnion: false,
	locale: 'en',
	tel_prefix: '+1',
	timezone: 'America/New_York',
	symbol: '$',
}

export const useWebsiteInfoStore = defineStore('websiteInfo', {
	state: (): CountryInfo => {
		const fs_websiteinfo = (Cookie.get('fs_websiteinfo') && JSON.parse(Cookie.get('fs_websiteinfo') as string) && !['cn', 'hk', 'mo', 'tw'].includes(JSON.parse(Cookie.get('fs_websiteinfo') as string)['website'])) ? JSON.parse(Cookie.get('fs_websiteinfo') as string) : DEFAULT_WEBSITE
		return ({
			id: fs_websiteinfo.id,
			iso_code: fs_websiteinfo.iso_code,
			currency: fs_websiteinfo.currency,
			country_name: fs_websiteinfo.country_name,
			website: fs_websiteinfo.website,
			language: fs_websiteinfo.language,
			area: fs_websiteinfo.area,
			countries_id: fs_websiteinfo.countries_id,
			language_id: fs_websiteinfo.language_id,
			warehouse: fs_websiteinfo.warehouse,
			isEuUnion: fs_websiteinfo.isEuUnion,
			locale: fs_websiteinfo.locale,
			tel_prefix: fs_websiteinfo.tel_prefix,
			timezone: fs_websiteinfo.timezone,
			symbol: fs_websiteinfo.symbol,
			seo_lang_code: fs_websiteinfo.seo_lang_code,
		})
	},
	actions: {},
})
